/* KönigPanda FAQ: in-page search, deep links, active topic, copy link.
   The page is fully usable without this file (native <details>). */
(() => {
  const root = document.querySelector('[data-kp-faq]');
  if (!root) return;

  const input = root.querySelector('[data-kp-faq-input]');
  const form = root.querySelector('[data-kp-faq-form]');
  const clear = root.querySelector('[data-kp-faq-clear]');
  const status = root.querySelector('[data-kp-faq-status]');
  const empty = root.querySelector('[data-kp-faq-empty]');
  const shopSearch = root.querySelector('[data-kp-faq-shop-search]');
  const topics = [...root.querySelectorAll('[data-kp-faq-topic]')];
  const items = [...root.querySelectorAll('[data-kp-faq-item]')];
  const navLinks = [...root.querySelectorAll('[data-kp-faq-nav]')];

  // "Rücksendung" must match "rucksendung", "ruecksendung" and "Rücksendung".
  const fold = (s, umlaut) => s.toLowerCase()
    .replace(/ä/g, umlaut ? 'ae' : 'a').replace(/ö/g, umlaut ? 'oe' : 'o')
    .replace(/ü/g, umlaut ? 'ue' : 'u').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[̀-ͯ]/g, '');

  const index = items.map((item) => {
    const q = item.querySelector('[data-kp-faq-q]');
    const topic = item.closest('[data-kp-faq-topic]');
    const heading = topic && topic.querySelector('h2');
    const text = `${q.textContent} ${item.querySelector('.rte').textContent} ${heading ? heading.textContent : ''}`;
    return { item, q, original: q.textContent, a: fold(text, true), b: fold(text, false) };
  });

  const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const looseRe = (term) => escapeRe(term)
    .replace(/ae|a/g, '(?:ae|ä|a)').replace(/oe|o/g, '(?:oe|ö|o)')
    .replace(/ue|u/g, '(?:ue|ü|u)').replace(/ss/g, '(?:ss|ß)');

  const highlight = (entry, terms) => {
    if (!terms.length) { entry.q.textContent = entry.original; return; }
    const re = new RegExp(`(${terms.map((t) => looseRe(fold(t, false))).join('|')})`, 'gi');
    const frag = document.createDocumentFragment();
    let last = 0;
    entry.original.replace(re, (m, _g, offset) => {
      frag.append(entry.original.slice(last, offset));
      const mark = document.createElement('mark');
      mark.textContent = m;
      frag.append(mark);
      last = offset + m.length;
      return m;
    });
    frag.append(entry.original.slice(last));
    entry.q.replaceChildren(frag);
  };

  const plural = (n) => (n === 1 ? root.dataset.resultsOne : root.dataset.resultsOther.replace('[n]', n));

  let openedBySearch = [];
  const run = (raw) => {
    const query = raw.trim();
    const terms = query.split(/\s+/).filter((t) => t.length > 1);
    clear.hidden = !query;
    openedBySearch.forEach((d) => { d.open = false; });
    openedBySearch = [];

    let hits = 0;
    index.forEach((entry) => {
      const match = !terms.length || terms.every((t) => entry.a.includes(fold(t, true)) || entry.b.includes(fold(t, false)));
      entry.item.hidden = !match;
      highlight(entry, match ? terms : []);
      if (match) hits += 1;
    });
    topics.forEach((t) => { t.hidden = !t.querySelector('[data-kp-faq-item]:not([hidden])'); });

    if (terms.length && hits > 0 && hits <= 3) {
      index.forEach(({ item }) => { if (!item.hidden && !item.open) { item.open = true; openedBySearch.push(item); } });
    }
    empty.hidden = !(terms.length && hits === 0);
    if (shopSearch) shopSearch.href = `${form.action}?q=${encodeURIComponent(query)}`;
    status.textContent = terms.length ? plural(hits) : '';

    const url = new URL(window.location.href);
    if (query) url.searchParams.set('q', query); else url.searchParams.delete('q');
    history.replaceState(history.state, '', url);
  };

  let timer;
  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => run(input.value), 120); });
  form.addEventListener('submit', (e) => { e.preventDefault(); clearTimeout(timer); run(input.value); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape' && input.value) { input.value = ''; run(''); } });
  clear.addEventListener('click', () => { input.value = ''; run(''); input.focus(); });

  // Deep links: #question-id opens and reveals that answer.
  const openFromHash = () => {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (_) { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !root.contains(target)) return;
    if (target.matches('[data-kp-faq-item]')) {
      clearTimeout(timer);
      if (input.value) { input.value = ''; run(''); }
      target.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  };
  window.addEventListener('hashchange', openFromHash);

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open && !openedBySearch.includes(item)) history.replaceState(history.state, '', `#${item.id}`);
    });
  });

  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-kp-faq-copy]');
    if (!btn) return;
    const url = new URL(window.location.href);
    // Keep the selected FAQ template (view=FAQs) and locale/preview context.
    // A copied answer must not inherit an unrelated FAQ search filter.
    url.searchParams.delete('q');
    url.hash = btn.dataset.kpFaqCopy;
    const label = btn.querySelector('span');
    const original = label.textContent;
    try {
      await navigator.clipboard.writeText(url.toString());
      label.textContent = root.dataset.copied;
      btn.classList.add('is-done');
      setTimeout(() => { label.textContent = original; btn.classList.remove('is-done'); }, 2200);
    } catch (_) {
      window.location.hash = btn.dataset.kpFaqCopy;
    }
  });

  // Active topic in the navigation.
  if (navLinks.length && 'IntersectionObserver' in window) {
    const byId = new Map(navLinks.map((a) => [a.hash.slice(1), a]));
    const visible = new Set();
    const setActive = () => {
      const current = topics.find((t) => visible.has(t));
      navLinks.forEach((a) => a.removeAttribute('aria-current'));
      const link = current && byId.get(current.id);
      if (!link) return;
      link.setAttribute('aria-current', 'true');
      const bar = link.closest('ul');
      if (bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: link.parentElement.offsetLeft - 16, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => (en.isIntersecting ? visible.add(en.target) : visible.delete(en.target)));
      setActive();
    }, { rootMargin: '-160px 0px -55% 0px' });
    topics.forEach((t) => t.id && io.observe(t));
  }

  window.addEventListener('beforeprint', () => items.forEach((d) => { d.dataset.wasOpen = d.open; d.open = true; }));
  window.addEventListener('afterprint', () => items.forEach((d) => { d.open = d.dataset.wasOpen === 'true'; }));

  const initial = new URL(window.location.href).searchParams.get('q');
  if (initial) { input.value = initial; run(initial); }
  openFromHash();
})();
